import React from "react";
import { Card, Checkbox, TextField, Select } from "@shopify/polaris";
import PropTypes from "prop-types";

import constant from "lib/constant/constant";
import { Banner } from "lib/components";

const Shipping = (props) => {
  const {
    handleChange = () => {},
    variantData = {},
    handleTitleChange = () => {},
    handleMeasurementChange = () => {},
  } = props;

  const {
    value: { MAX_MEASUREMENT = 999 },
  } = constant;

  const { isShipping = false, weight = "", weightUnit = "", measurement = {} } = variantData || {};
  const options = constant.OPTIONS;
  const selectWeight = (
    <Select
      id="selectWeight"
      value={weightUnit || ""}
      label="select weight"
      placeholder="select weight"
      onChange={(value) => handleTitleChange(constant.WEIGHT_UNIT, value)}
      labelHidden
      options={options}
    />
  );

  const renderMeasurement = () => {
    const { length = {}, width = {}, height = {} } = measurement || {};
    const { value: lengthValue = 0 } = length || {};
    const { value: widthValue = 0 } = width || {};
    const { value: heightValue = 0 } = height || {};
    return (
      <>
        <TextField
          id="length"
          label="Length"
          value={(lengthValue && lengthValue.toString()) || ""}
          placeholder="Length (cm)"
          min={0}
          max={MAX_MEASUREMENT}
          onChange={(value) => handleMeasurementChange(constant.LENGTH, Number(value))}
        />
        <br />
        <TextField
          id="width"
          label="Width"
          value={(widthValue && widthValue.toString()) || ""}
          placeholder="Width (cm)"
          min={0}
          max={MAX_MEASUREMENT}
          onChange={(value) => handleMeasurementChange(constant.WIDTH, Number(value))}
        />
        <br />
        <TextField
          id="height"
          label="Height"
          value={(heightValue && heightValue.toString()) || ""}
          placeholder="Height (cm)"
          min={0}
          max={MAX_MEASUREMENT}
          onChange={(value) => handleMeasurementChange(constant.HEIGHT, Number(value))}
        />
      </>
    );
  };

  return (
    <Card title="Shipping" id="variantShipping">
      <Card.Section>
        <Checkbox
          id="shippingCheckbox"
          label="This is a physical product"
          checked={isShipping}
          onChange={(value) => {
            handleTitleChange(constant.IS_SHIPPING, value);
            if (!value) {
              handleTitleChange(constant.WEIGHT, null);
              handleTitleChange(constant.WEIGHT_UNIT, "");
            }
          }}
        />
        {!isShipping && (
          <div>
            <br />
            <Banner isOpen status="info" isScrollTop={false}>
              <p>If you uncheck this, shipping value will not be calculated at the checkout.</p>
            </Banner>
          </div>
        )}
      </Card.Section>
      {isShipping && (
        <Card.Section title="WEIGHT">
          <p>Used to calculate shipping rates at checkout.</p>
          <br />
          <TextField
            id="weight"
            label="Weight"
            type="number"
            value={(weight && weight.toString()) || ""}
            placeholder="0"
            onChange={(value) => handleChange(constant.WEIGHT, Number(value))}
            connectedRight={selectWeight}
          />
          <br />
          {renderMeasurement()}
        </Card.Section>
      )}
    </Card>
  );
};

Shipping.propTypes = {
  handleChange: PropTypes.func.isRequired,
  handleTitleChange: PropTypes.func.isRequired,
  handleMeasurementChange: PropTypes.func.isRequired,
  variantData: PropTypes.objectOf(PropTypes.shape).isRequired,
};

export default Shipping;
